import React, { useState } from "react";
import { Typography, notification, Button, Divider } from "antd";

import {
  loginWithJWT,
  loginWithGoogle,
  loginGoogle,
  changeStatus,
  setToken,
} from "../../redux/actions/auth/loginActions";
import { connect } from "react-redux";
import axiosGlobal from "../../axios-global";
// const axios = axiosGlobal();

import "../../assets/css/login.css";
import { getAPIUrl } from "../../configs/global_var";

const { Text } = Typography;

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOutsideClick = (e) => {
    props.onClose();
  };

  const login = async () => {
    setLoading(true);
    const axios = await axiosGlobal();
    try {
      const resAdmin = await axios.post("/login/cms", { email, password });
      if (!resAdmin.data.data.token || resAdmin.data.data.userStatus === "4") {
        axios
          .post("/login/junior", { email, password })
          .then((res) => {
            if (res.data.data.authStatus) {
              props.changeStatus(true);
              props.setToken(res.data.data.token);
              props.onClose();
              openNotification(res.data.message, res.data.data.authStatus);
            } else {
              openNotification(res.data.message, res.data.data.authStatus);
            }
            setLoading(false);
          })
          .catch((err) => {
            if (err.message === "Network Error") {
              openNotification(
                "Gagal mengambil data lembaga, silahkan periksa koneksi anda",
                false
              );
            } else {
              openNotification("email atau password salah", false);
            }
          })
          .then(() => setLoading(false));
        return;
      }

      const resInst = await getAPIUrl();
      const instId = resInst[0].inst_id;

      try {
        const resTokenInst = await axios.post(`/institute/${instId}`, {
          token: resAdmin.data.data.token,
        });
        // window.open(
        //   `http://localhost:3000/sentinel/pages/login?token=${resAdmin.data.data.token}&tokenInst=${resTokenInst?.data?.data?.tokenInst}&ecommerceUrl=${window.location.href}`,
        //   "_self"
        // );
        window.open(
          `https://sentinel.shratech.com/sentinel/pages/login?token=${resAdmin.data.data.token}&tokenInst=${resTokenInst?.data?.data?.tokenInst}&ecommerceUrl=${window.location.href}`,
          "_self"
        );
      } catch (error) {
        openNotification(error?.response?.data?.message, false);
      }
    } catch (err) {
      openNotification(
        "Gagal mengambil data lembaga, silahkan periksa koneksi anda",
        false
      );
    }
  };

  const openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 3,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  return (
    <div
      className={props.isOpen ? "login-active" : "login-inactive"}
      onClick={handleOutsideClick}
    >
      <div
        className="modal-body-login"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="modal-login">
          <h2>Login</h2>
          <div className="form-login">
            <div className="col-3">
              <input
                className="effect-1"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <span className="focus-border"></span>
            </div>
            <div className="col-3">
              <input
                className="effect-1"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
              <span className="focus-border"></span>
            </div>
            <Button
              className="button-apply"
              onClick={login}
              style={{ marginTop: "1rem" }}
            >
              <h5 style={{ color: "#fff", margin: "auto" }}>Login</h5>
            </Button>
            <Divider>
              <p style={{ color: "grey" }}>atau</p>
            </Divider>
            <Button className="button-cancel" onClick={props.loginGoogle}>
              <h5 style={{ color: "#7367f0", margin: "auto" }}>
                Login / Daftar dengan Google
              </h5>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.login.isLogin,
  };
};
export default connect(mapStateToProps, {
  loginWithJWT,
  loginWithGoogle,
  loginGoogle,
  changeStatus,
  setToken,
})(Login);
